

import { BasicClientCommand } from "../BasicClientCommand";

export class PrivateOfferOfferDialogClientCommand extends BasicClientCommand {
    public execute(commandVars: any = null): void {
        return;
    }
}

